import User from "../User.jsx"
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { useCollapse } from 'react-collapsed'
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Subtitle from '../Subtitle'
import Fields from '../Fields'


// Fonction utilitaire pour obtenir la classe d'état en fonction de l'état du ticket
export const getStateUtil = (state) => {
    switch (parseInt(state)) {
        case 1:
            return {class: 'bg-mlime', label_name: 'Traité'}
        default:
            return {class: 'bg-morange', label_name: 'En cours'}
    }
};

const PanelTicket = ({ data }) => {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse()

    const fields = [
        {
            key: 'date_creation',
            name: 'Date de création',
            format: 'date_timestamp',
            date_format: 'dd/MM/yyyy HH:mm:ss'
        }, {
            key: 'user_delegated_to',
            name: 'Délégué à',
            format: 'user',
        }
    ]
    
    let stateInfos = getStateUtil(data.state)
    
    return (
        <div className={`grid grid-cols-1 relative`}>

            <div className="p-4 border mb-4 timeline-big-item">
                <Subtitle>
                    <div className="flex justify-between flex-col md:flex-row">
                        <div># {data.id} {data.titre_txt ? '- ' + data.titre_txt : '' }</div>
                        <span className={`${stateInfos.class} w-2/4 md:w-auto text-white py-1 px-2 font-bold text-sm rounded-md text-center`}>{stateInfos.label_name}</span>
                    </div>                  
                </Subtitle>
                

                <div className="px-2">
                    <Fields fields={fields} data={data} wrapper_class="py-2" />
                </div>


                <div className="text-center mt-3">
                    
                    <NavLink
                        to={`${data.id}`}
                        className={({ isActive, isPending }) =>
                            `bg-mlime hover:bg-lime-600 font-bold py-2 text-white p-3  rounded-3xl  ${isActive ? "text-indigo-600" :
                                isPending ? "text-cyan-600" :
                                    ""
                            }`
                        }>
                        <FontAwesomeIcon className="" icon="fa-solid fa-eye" />
                        <span className="ml-2">Voir le détail</span>
                    </NavLink>
                </div>
            </div>
        </div>
    )
    
    // return (
    //     <div className="relative block flex justify-between rounded-lg p-4">
    //         <div className="">
    //             <div className="flex items-center gap-4 mb-2">
    //                 <h3 className="text-lg font-bold text-gray-900 sm:text-xl">
    //                         # {data.id}
    //                 </h3>
    //                 <div className="text-sm text-gray-500 italic ml-10">{format(new Date(data.date_creation * 1000), 'dd/MM/yyyy HH:mm:ss')}</div>

    //             </div>

    //             {data.user_delegated_to && (
    //                 <div className="flex gap-2 items-center text-sm ml-5">
    //                     <FontAwesomeIcon icon="fa-solid fa-arrow-right-long" />
    //                     <span>délégué à : </span>
    //                     <User user={data.user_delegated_to} />
    //                 </div>
    //             )}


    //         </div>

            


    //         <div className="text-right">
    //             <div className="mb-2">
    //                 <span className={`${stateInfos.class} py-1 px-2 font-bold text-sm rounded-md`}>{stateInfos.label_name}</span>
    //             </div>
    //             <NavLink
    //                 to={`${data.id}`}
    //                 className={({ isActive, isPending }) =>
    //                     `bg-mlime hover:bg-lime-600 font-bold py-1 text-white px-3 rounded-3xl text-sm ${isActive ? "text-indigo-600" :
    //                         isPending ? "text-cyan-600" :
    //                             ""
    //                     }`
    //                 }>
    //                 <FontAwesomeIcon className="" icon="fa-solid fa-eye" />
    //                 <span className="ml-2">Voir le détail</span>
    //             </NavLink>
    //         </div>
    //     </div>
    // )
}
export default PanelTicket;